const dbName = 'mmconnect-kv-store';
const storeName = 'sdk-kv-store';
const sessionKeys = [
  'sessions:master-list',
  'pending_session_request',
  'cache_wallet_getSession',
  'cache_eth_accounts',
  'cache_eth_chainId',
  'multichain-transport',
];
const sessionKeyPrefixes = ['session:', 'nonce:', 'latest-nonces:'];
const giveUpMs = 3000;

function isSessionKey(key: IDBValidKey): key is string {
  return (
    typeof key === 'string' &&
    (sessionKeys.includes(key) || sessionKeyPrefixes.some(prefix => key.startsWith(prefix)))
  );
}

function openExisting(factory: IDBFactory): Promise<IDBDatabase | null> {
  return new Promise((resolve, reject) => {
    const request = factory.open(dbName);
    request.onupgradeneeded = () => request.transaction?.abort();
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => {
      if (request.error?.name === 'AbortError') resolve(null);
      else reject(request.error);
    };
  });
}

async function deleteSessionKeys(factory: IDBFactory): Promise<void> {
  const db = await openExisting(factory);
  if (!db) return;
  try {
    if (!db.objectStoreNames.contains(storeName)) return;
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      const keys = store.getAllKeys();
      keys.onsuccess = () => {
        keys.result.filter(isSessionKey).forEach(key => store.delete(key));
      };
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  } finally {
    db.close();
  }
}

export async function forgetMetaMaskSessions(
  factory: IDBFactory | undefined = typeof indexedDB === 'undefined' ? undefined : indexedDB,
): Promise<void> {
  if (!factory) return;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const giveUp = new Promise<void>(resolve => {
    timer = setTimeout(() => {
      console.warn('Gave up clearing the stored MetaMask sessions.');
      resolve();
    }, giveUpMs);
  });
  try {
    await Promise.race([deleteSessionKeys(factory), giveUp]);
  } catch (error) {
    console.warn('Could not clear the stored MetaMask sessions:', error);
  } finally {
    clearTimeout(timer);
  }
}
